import { useQuery } from "@tanstack/react-query";
import { getRuleHistory } from "../../../../../services/rules";

/**
 * Fetches the change history for a rule. Only enabled while the
 * Details popup is open — saves an extra round-trip on page mount.
 */
export function useRuleHistoryQuery({ ruleId, enabled }) {
  return useQuery({
    queryKey: ["rule-history", ruleId],
    queryFn: () => getRuleHistory(ruleId),
    enabled: Boolean(ruleId && enabled),
    refetchOnWindowFocus: false,
    retry: 1,
  });
}
